import { EStateStatus } from '@app/app.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEventCardState } from './event-card.reducer';

const _selectEventCard = createFeatureSelector<IEventCardState>('eventCard');
export const selectEventCard = createSelector(_selectEventCard, (item) => item);
export const selectEventId = createSelector(
  _selectEventCard,
  (item) => item?.id ?? null,
);
export const selectEventType = createSelector(
  _selectEventCard,
  (item) => item?.eventType ?? null,
);
export const selectEventInfo = createSelector(
  _selectEventCard,
  (item) => item?.eventInfo ?? null,
);
export const selectEventPvsTaskList = createSelector(
  _selectEventCard,
  (item) => item?.eventPvsTaskList ?? null,
);
export const selectEventCardIsLoading = createSelector(
  _selectEventCard,
  (state) => state?.status === EStateStatus.LOADING,
);
export const selectEventActiveProtocol = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolInfo ?? null,
);
export const selectEventActiveProtocolSteps = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolSteps ?? null,
);
export const selectEventActiveProtocolStepsPhase = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolStepsPhase ?? EStateStatus.PENDING,
);
export const selectEventActiveProtocolGantt = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolGantt ?? null,
);
export const selectEventActiveProtocolGanttPhase = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolGanttPhase ?? EStateStatus.PENDING,
);
export const selectEventActiveProtocolGanttError = createSelector(
  _selectEventCard,
  (state) => state?.activeProtocolGanttError ?? null,
);
export const selectEventActiveProtocolGanttIsLoading = createSelector(
  selectEventActiveProtocolGanttPhase,
  (phase) => phase === EStateStatus.LOADING,
);
export const selectEventHistProtocols = createSelector(
  _selectEventCard,
  (state) => state?.histProtocols ?? null,
);
